import tokens from './tokens'

const { jump } = tokens

export default {
  jump
}